import { AddToCartRequest, AddToCartResponse } from '@/actions/CartActions';

import { AddToCartCallbackParams } from './types';

export const onAddToCart = (
  params: AddToCartCallbackParams,
  dispatchCallback: (response: AddToCartResponse, requestQuantity: number) => void
) => {
  const { activeSku, quantity, setQuantity, dispatch, addItemToCart, personalizationData } = params;
  return () => {
    if (!activeSku) {
      return Promise.resolve(null);
    }
    const request: AddToCartRequest & {
      quantity: number;
    } = {
      sku_id: activeSku.id as string,
      quantity,
      item_origin: 'ECOMMERCE',
    };

    if (personalizationData) {
      request.user_selection_uuid = personalizationData.uuid;
      request.sku_id = personalizationData.sku_id;
    }
    return dispatch(addItemToCart(request))
      .then((response) => {
        dispatchCallback(response, request.quantity);
      })
      .catch((err) => {
        const { trigger } = err;
        if (err.category && err.category.reason === 'sku-unavailable' && Number(trigger) !== 0) {
          setQuantity(Number(trigger));
        }
      });
  };
};
